import api from './api';

export default {
  getGroups() {
    return new Promise((resolve, reject) => {
      api
        .get('question-group', {
          params: {
            includes: 'journey',
            orderby: 'number'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  updateGroup(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`question-group/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  updateGroupOrder(newOrder) {
    return new Promise((resolve, reject) => {
      api
        .put(`question-group/resort`, { ...newOrder })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  addGroup(group) {
    return new Promise((resolve, reject) => {
      api
        .post('question-group', group)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
